import { validateRules } from '@foradevelopment/fora-ui';

import { isParameterDateWithinValidityPeriod } from './helpers/isParameterDateWithinValidityPeriod';
import { typedT } from '../../../i18n/i18n';
import { isEndDateLastDayOfNextMonthOrLater } from './helpers/isEndDateLastDayOfNextMonthOrLater';
import { isAfterDate } from './helpers/isAfterDate';

/** Validation should not be needed since the datepicker forces a certain range. This is to cover if the datepicker does not work properly. */
export const validateParameterEndDate =
  (fokParameterValidity?: { validFrom: string; validTo: string | null }, parameterStartDate?: string) =>
  (value: string) => {
    if (!value) {
      // Not required
      return [];
    }

    const rules = [];

    if (parameterStartDate) {
      rules.push(isAfterDate(typedT('errorMessages.validation.parameterEndDate1'), parameterStartDate));
    }

    rules.push(isEndDateLastDayOfNextMonthOrLater(typedT('errorMessages.validation.parameterEndDate2')));

    if (fokParameterValidity) {
      rules.push(
        isParameterDateWithinValidityPeriod(typedT('errorMessages.validation.parameterEndDate3'), fokParameterValidity)
      );
    }

    return validateRules(rules, value);
  };
